import React from "react";
import { isNil } from "lodash";

const FormatDisplay = item => {
  let value = item.value;

  return `${item.label}: ${value}`;
};

const DealerOfficeFilterDisplay = ({ filters, onChange }) => {
  const items = filters
    ? Object.keys(filters)
        .filter(f => f !== "search" && f != undefined && f != null)
        .map(k => {
          return {
            label: k,
            value: filters[k],
          };
        })
    : [];

  if (!items.length) return null;

  return (
    <div className="filter-display">
      {items
        .filter(i => !isNil(i.value) && i.value != "")
        .map(item => (
          <div className="filter-display-item" key={item.label}>
            {FormatDisplay(item)}
          </div>
        ))}

      <div
        onClick={() => {
          const nextFilters = {
            ...filters,
          };
          onChange(nextFilters);
        }}
        className="clear-button"
      >
        (clear)
      </div>
    </div>
  );
};

export default DealerOfficeFilterDisplay;
